interface Inviter {
  firstName?: string | null;
  lastName?: string | null;
  emailAddress?: string | null;
}

/**
 * Builds a display name for the user who sent an account invitation.
 * Falls back to the email address when the inviter has no name set yet
 * (invited users only get a name once they complete signup).
 */
export const getInvitedByName = (
  inviter?: Inviter | null,
): string | undefined => {
  if (!inviter) return undefined;

  const fullName = [inviter.firstName, inviter.lastName]
    .map((namePart) => namePart?.trim())
    .filter(Boolean)
    .join(' ');

  return fullName || inviter.emailAddress?.trim() || undefined;
};
